module.exports = __webpack_public_path__ + "img/20.80f1d736.jpg";